import React, { useRef, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { saveSpentDays } from '../../../actions/project';
import { InlineInput } from '../../Form';
import { validateDayInput } from '../../../utils/datetime';

const SpentInputCell = ({ value, row: { original } }) => {
  const { memberId: assignedUserId, editable } = original;
  const dispatch = useDispatch();
  const inputRef = useRef();
  const [displayedVal, setDisplayedVal] = useState(value);

  useEffect(() => {
    setDisplayedVal(value);
  }, [value]);

  return (
    <InlineInput
      type="number"
      min={0}
      step="any"
      register={inputRef}
      value={displayedVal || ''}
      onChange={(e) => {
        const { value: inputVal } = e.target;
        if (!inputVal || inputVal === '0') {
          setDisplayedVal(inputVal);
        }
        const days = parseFloat(parseFloat(inputVal).toFixed(3)) || 0;
        dispatch(saveSpentDays(assignedUserId, days));
      }}
      onBlur={(e) => {
        const { value: inputVal } = e.target;
        const days = parseFloat(
          parseFloat(validateDayInput(inputVal)).toFixed(3),
        );
        dispatch(saveSpentDays(assignedUserId, days));
      }}
      onKeyPress={(e) => {
        if (e.key === 'Enter') {
          inputRef.current.blur();
        }
      }}
      disabled={!editable}
      standalone
    />
  );
};

export default SpentInputCell;
